require('../../../styles/_OTPInput.scss');
// @ vendors
const React = require('react');
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
// @ commons
import { formatText, FormattedText } from 'core/i18n';
// @ utilities
const classNames = require('classnames');
// @ components
const { InputText } = require('components/inputText/inputText');
// @ actions
const formActions = require('react-redux-form').actions;
const stepsActions = require('actions/stepsActions');

class OtpViewAC extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isValidOTP: false,
            loadingOTPCode: false,
            loadingReloadOTPCode: false,
            disabledOTP: false,
        };

        this.handleValidateOtp = this.handleValidateOtp.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
    }

    handleReloadOTPCode = () => {
        this.props.reloadOTPCode();
    };

    handleValidateOtp(value) {
        const { actions, operationType, userProfile, formActions } = this.props;
        const accessToken = userProfile.accessToken;
        if (value) {
            actions.verifyOTP(operationType, value, accessToken, (res, data) => {
                if (res) {
                    if (data.allVerificationDone) {
                        this.setState({
                            isValidOTP: true,
                            disabledOTP: true,
                        });
                        formActions.setValidity('userProfile.otpCodeAC', { valid: true });
                        this.props.complete();
                    }
                } else {
                    formActions.setValidity('userProfile.otpCodeAC', { valid: false });
                }
            });
        }
    }

    handleOnChange(e) {
        const handleValidateOtp = this.handleValidateOtp;
        const value = e.target.value;
        if (value.length === 4) {
            handleValidateOtp(value);
        }
    }

    render() {
        const { userProfile, userProfileForm, formActions } = this.props;
        const iconClass = classNames(
            { 'icons--icon-check': this.state.isValidOTP },
            { hidden: !this.state.isValidOTP }
        );
        const disabledOTP = this.state.disabledOTP;

        return (
            <div>
                <div className="form__input">
                    <label className="top-label">
                        <FormattedText value="otp-confirmationCode" />
                    </label>
                    <br />
                    <label className="sub-label">
                        <FormattedText value="otp-enterCode" />
                    </label>
                </div>
                <div className="promo-code__input row">
                    <div className="col-xs-9 col-sm-6">
                        <InputText
                            profileModel={'userProfile.otpCodeAC'}
                            id="otpCode"
                            type="text"
                            maxLength={4}
                            onChange={this.handleOnChange}
                            messagesError={{
                                valid: formatText('validation-otpInvalid'),
                                required: formatText('validation-fieldRequired'),
                            }}
                            userProfile={userProfile}
                            formActions={formActions}
                            userProfileForm={userProfileForm}
                            disabled={disabledOTP}
                            {...this.props}
                        />
                    </div>
                    <div className="col-xs-2 col-sm-2">
                        <span className={iconClass}></span>
                    </div>
                </div>
                <p className="prospects-disclaimer">
                    <FormattedText value="stepsTitles-jointHolderDataDisclaimerOTP1" />
                    <a
                        className="otp-block__link"
                        href="#"
                        onClick={event => {
                            event.preventDefault();
                            this.handleReloadOTPCode();
                        }}
                    >
                        <FormattedText value="stepsTitles-jointHolderDataDisclaimerOTP2" />
                    </a>
                    <FormattedText value="stepsTitles-jointHolderDataDisclaimerOTP3" />
                </p>
            </div>
        );
    }
}

module.exports.constructor = OtpViewAC;
module.exports.OtpViewAC = connect(
    state => ({
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
    }),
    dispatch => ({
        actions: bindActionCreators(stepsActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
    })
)(OtpViewAC);
